import React, { useEffect, useMemo, useState } from "react";
import { ActivityIndicator, Dimensions, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { addCommasToNumber, formatEpochIntoYear, groupByMonth, isFromTDLPlatform, returnDateInStringV2 } from "../utils";
import { TRANSACTION_TYPE } from "./type";
import { Divider } from "../../divider/Divider";
import { AppBottomNav } from "../../appBottomNav/AppBottomNav";
import BottomSheet from "../BottomSheet";
import { convertTimeStampToFormattedTime, convertTimeStampToMonth, isFontMobile, isMobile, isMobileView } from "../../stack/utils";
import { Image } from "../../image/Image";
import TypographyDLSBase from "../../typography/TypographyDLS.base";
import Stepper from "../../stepper/Stepper";
import ThemeProvider from "@voltmoney/theme";
import CustomHeader from "../../customHeader/CustomHeader";
import { getRepaymentExpectedDateBy } from "./utils";
import { Button } from "../../button/Button";
import ButtonDLSBase from "../../button/ButtonDLS.base";
const TransactionPageRevamp = ({ height, data, goToEmailAction, triggerAction, navigationAction, showEmail, showOutstanding = true, stepperData, bankCode, bankAccountNumber, showBottomNavBar, goBackAction, platform, isFromRejectedWithdrawal, withdrawalRejectedData, isFromWithdrawalRejection, goToRepaymentAction, principalOutStandingAmount, isFromRejectedRepayment, type, title, subTitle, ctaLabel, closeLoaderAction, }) => {
    const [_modalData, setModalData] = useState(undefined);
    const [emailLoading, setEmailLoading] = useState(false);
    const isfromTDL = isFromTDLPlatform();
    let modalContentHeight = isFontMobile()
        ? _modalData && _modalData?.outStandingBalance
            ? height < 480 ? height - 20 : 464
            : height < 610 ? height - 20 : 592
        : _modalData && _modalData?.outStandingBalance
            ? height < 480 ? height - 20 : 464
            : height < 590 ? height - 20 : 572;
    const [_data, setData] = useState(groupByMonth(data));
    const [tempData, setTempData] = useState(data);
    const [settledData, setSettledData] = useState([]);
    const [modalHeight, setModalHeight] = useState(modalContentHeight);
    const [showModal, setShowModal] = useState(false);
    const [isDismissable, setDismissable] = useState(true);
    const [_showEmail, setShowEmail] = useState(showEmail);
    const [_settleDataLength, setSettledDataLength] = useState(0);
    const [showWithdrawalRejectedCard, setShowWithdrawalRejectedCard] = useState(false);
    const [showRepaymentRejectedCard, setShowRepaymentRejectedCard] = useState(false);
    const [indexOfRow, setIndexOfRow] = useState(0);
    const [repaymentRejectedCard, setRepaymentRejectionCard] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    useEffect(() => {
        setShowWithdrawalRejectedCard(isFromRejectedWithdrawal);
        setShowRepaymentRejectedCard(isFromRejectedRepayment);
        if (isFromRejectedWithdrawal === true) {
            setShowWithdrawalRejectedCard(isFromRejectedWithdrawal);
            setIndexOfRow(0);
        }
        else if (isFromRejectedRepayment === true) {
            setShowRepaymentRejectedCard(isFromRejectedRepayment);
            setShowWithdrawalRejectedCard(false);
            setIndexOfRow(0);
        }
        else {
            setShowWithdrawalRejectedCard(false);
            setShowRepaymentRejectedCard(false);
        }
    }, [isFromRejectedWithdrawal, isFromRejectedRepayment]);
    useEffect(() => {
        return () => {
            setShowWithdrawalRejectedCard(false);
        };
    }, []);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const pendingSettlement = "PENDING_SETTLEMENT";
    const settled = "SETTLED";
    const REJECTED = 'REJECTED';
    const FAILED = 'FAILED';
    const getModalHeight = () => {
        let _modalContentHeight;
        if (Platform.OS === 'web') {
            _modalContentHeight = _modalData && _modalData?.outStandingBalance
                ? height < 470
                    ? height - 20
                    : 464
                : height < 580
                    ? height - 20
                    : 572;
        }
        else {
            _modalContentHeight = _modalData && _modalData?.outStandingBalance ? height < 570 ? height - 50 : 650 : height > 510 ? 650 : height - 70;
        }
        return modalContentHeight;
    };
    useEffect(() => {
        const tempTransactionData = [];
        const tempSetteledData = [];
        for (let i = 0; i < data?.length; i++) {
            if (data[i].transactionStatus == pendingSettlement) {
                tempTransactionData.push(data[i]);
            }
            else
                tempSetteledData.push(data[i]);
        }
        setTempData(tempTransactionData);
        setSettledData(groupByMonth(tempSetteledData));
        setSettledDataLength(data?.length);
    }, [data]);
    useEffect(() => {
        setModalHeight(getModalHeight());
    }, [_modalData]);
    useEffect(() => {
        setData(groupByMonth(data));
    }, [data]);
    const selectTransaction = (item, index) => {
        setModalData(item);
        setIndexOfRow(index);
        if (item?.transactionStatus === FAILED) {
            setShowWithdrawalRejectedCard(true);
            setShowModal(false);
            item.description.includes("Repayment") ? setRepaymentRejectionCard(true) : setRepaymentRejectionCard(false);
        }
        else {
            setShowWithdrawalRejectedCard(false);
            setShowModal(true);
        }
    };
    useEffect(() => {
        if (repaymentRejectedCard || showRepaymentRejectedCard) {
            setModalHeight(Platform.OS !== "web" ? 600 : 520);
        }
    }, [repaymentRejectedCard, showRepaymentRejectedCard]);
    const goToEmailScreenAction = async () => {
        setEmailLoading(true);
        goToEmailAction &&
            await triggerAction(goToEmailAction);
        setShowEmailModal(true);
        setEmailLoading(false);
    };
    const transactionPendingCard = () => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            ...isfromTDL && {
                backgroundColor: '#FFF4DC',
                borderRadius: 4,
                paddingVertical: 4,
                paddingHorizontal: 8
            }
        } },
        React.createElement(Icon, { name: IconTokens.TransactionInProgress }),
        React.createElement(View, { style: { width: 4 } }),
        React.createElement(View, { style: { paddingRight: 20 } },
            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Processing", color: ColorTokens.MUSTARD_YELLOW_1 }))));
    const showTransactionFailedCard = () => (React.createElement(View, { style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 20
        } },
        React.createElement(Icon, { name: IconTokens.RED_ERROR_ICON }),
        React.createElement(View, { style: { width: 4 } }),
        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Failed", color: ColorTokens.System_Error })));
    const handleCloseEmailModal = async () => {
        setShowEmailModal(false);
        await triggerAction(closeLoaderAction);
    };
    const modalContentPresenter = () => {
        const item = _modalData;
        let expectedSettlingDate = item?.expectedSettlingDate;
        if (showWithdrawalRejectedCard || showRepaymentRejectedCard) {
            const data = item ? item : withdrawalRejectedData;
            const amount = data ? addCommasToNumber(data.amount) : '';
            const settledOn = data ? formatEpochIntoYear(data.settledOn) : "";
            const completedOn = data ? formatEpochIntoYear(data.completedOn) : "";
            const createdOn = data ? formatEpochIntoYear(data.createdOn) : "";
            const title = item?.description?.includes("Repayment");
            return showRepaymentRejectedCard || title ? (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flex: 1 }, onPress: () => {
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'space-between',
                        paddingTop: 16,
                        paddingHorizontal: 16
                    } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 12 } },
                        React.createElement(View, { style: {
                                marginRight: 16, alignContent: 'center', alignItems: 'center', alignSelf: 'center'
                            } },
                            React.createElement(Icon, { name: IconTokens.Debit, size: IconSizeTokens.XXXXXL })),
                        React.createElement(View, { style: { flexDirection: 'column' } },
                            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Repayment amount", color: ColorTokens.Grey_Charcoal }),
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                } },
                                React.createElement(Typography, { label: `₹`, fontSize: isFontMobile() ? FontSizeTokens.XL : FontSizeTokens.MD, lineHeight: isFontMobile() ? 28 : 24, fontWeight: "600", color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                                React.createElement(View, { style: { marginBottom: Platform.OS === "android" ? 2 : 0 } },
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H3B, label: `${showRepaymentRejectedCard ? addCommasToNumber(Number(withdrawalRejectedData?.actualAmountCollected)) : addCommasToNumber(item?.amount)}`, color: ColorTokens.Grey_Night })),
                                React.createElement(View, { style: {
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        alignContent: 'center',
                                        alignSelf: 'center',
                                        marginLeft: 12
                                    } },
                                    React.createElement(Icon, { name: IconTokens.RED_ERROR_ICON }),
                                    React.createElement(View, { style: { width: 4 } }),
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Failed", color: ColorTokens.System_Error })))))),
                React.createElement(View, { style: {
                        backgroundColor: 'white',
                        paddingBottom: 16,
                        marginHorizontal: -16
                    } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(ScrollView, { scrollEnabled: true, nestedScrollEnabled: true, style: {
                        flexDirection: 'column',
                        paddingHorizontal: 16,
                        height: 400,
                        paddingBottom: 90
                    } },
                    React.createElement(View, { style: {
                            borderRadius: 8,
                            backgroundColor: '#FFF6E3',
                            paddingVertical: 8,
                            paddingHorizontal: 16,
                            marginBottom: 16
                        } },
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
                            React.createElement(Text, { style: {
                                    fontSize: 12,
                                    lineHeight: 18,
                                    fontFamily: 'Inter',
                                    fontWeight: '400',
                                    textAlign: 'left',
                                    flex: 1,
                                    color: 'black'
                                } },
                                React.createElement(Text, { style: {
                                        textAlign: 'left',
                                        marginRight: 2,
                                        fontSize: 12,
                                        lineHeight: 18,
                                        fontFamily: 'Inter',
                                        fontWeight: '700',
                                        color: 'black'
                                    } }, "Note: "),
                                "Any amount deducted from your account will be refunded to your account in 5-7 business days"))),
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(View, null,
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Date", color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${createdOn}`, color: ColorTokens.Grey_Night }))),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Transaction reference number", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${showRepaymentRejectedCard ? withdrawalRejectedData?.pgResponseDetails?.pgTrackingId : item?.utrNumber}`, color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Payment mode", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${showRepaymentRejectedCard ? withdrawalRejectedData?.pgResponseDetails?.paymentMode : item?.modeOfTransfer}`, color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Type", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `Credit`, color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Outstanding balance", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${addCommasToNumber(principalOutStandingAmount)}`, color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: {
                        marginTop: 16,
                        alignItems: 'center',
                        backgroundColor: 'white',
                        width: '100%'
                    } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk, width: Dimensions.get('window').width }),
                    React.createElement(View, { style: {
                            paddingHorizontal: 16,
                            paddingTop: 16,
                            paddingBottom: 16,
                            alignContent: 'center',
                            alignSelf: 'center',
                            width: '100%',
                            marginBottom: Platform.OS === "ios" ? 8 : 0
                        } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", width: ButtonWidthTypeToken.FULL, onPress: () => {
                                setShowWithdrawalRejectedCard(false);
                                setShowModal(false);
                                setShowRepaymentRejectedCard(false);
                            } })))))
                : (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, flex: 1 } },
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            justifyContent: 'space-between',
                        } },
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 12 } },
                            React.createElement(View, { style: { marginRight: 16, alignContent: 'center', alignItems: 'center' } },
                                React.createElement(Icon, { name: IconTokens.Credit, size: IconSizeTokens.XXXXXL })),
                            React.createElement(View, { style: { flexDirection: 'column' } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Withdrawal request failed", color: ColorTokens.Grey_Charcoal }),
                                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                                    React.createElement(Typography, { label: `₹`, fontSize: isFontMobile() ? FontSizeTokens.XL : FontSizeTokens.MD, lineHeight: isFontMobile() ? 28 : 24, fontWeight: "600", color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                                    React.createElement(View, { style: { marginBottom: Platform.OS === "android" ? 2 : 0 } },
                                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H3B, label: `${amount}`, color: ColorTokens.Grey_Night })))))),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingBottom: 16,
                            marginHorizontal: -16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                        React.createElement(View, null,
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Amount", color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `₹${amount}`, color: ColorTokens.Grey_Night })),
                        React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', alignContent: 'center' } },
                            React.createElement(Icon, { name: IconTokens.RED_ERROR_ICON }),
                            React.createElement(View, { style: { width: 4 } }),
                            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "Failed", color: ColorTokens.System_Error }))),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Request failed on ", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${item ? settledOn : completedOn} `, color: ColorTokens.Grey_Night })),
                    React.createElement(View, { style: {
                            backgroundColor: 'white',
                            paddingVertical: 16
                        } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: "Withdrawal request placed on", color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: `${createdOn}`, color: ColorTokens.Grey_Night }))));
        }
        else {
            const ListItems = [
                (item?.transactionStatus !== settled && item?.transactionType !== TRANSACTION_TYPE.CREDIT) &&
                    {
                        title: 'Withdrawal status',
                        value: `${item?.transactionStatus === settled ? "Completed" : "In progress"}`
                    },
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) &&
                    {
                        title: 'Transaction reference number', value: `${item?.utrNumber}`
                    },
                item?.transactionStatus === settled &&
                    {
                        title: 'Date', value: `${returnDateInStringV2(item?.settledOn)}`
                    },
                (item?.transactionStatus !== settled && item?.transactionType !== TRANSACTION_TYPE.CREDIT) &&
                    {
                        title: 'Bank account', value: `${bankAccountNumber}`
                    },
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) &&
                    {
                        title: 'Payment mode',
                        value: `${item?.modeOfTransfer === "Unified Payments" ? "UPI" : item?.modeOfTransfer}`
                    },
                item?.transactionStatus === settled &&
                    {
                        title: 'Type', value: `${item.transactionType}`
                    },
                item?.transactionStatus === settled
                    && showOutstanding && {
                    title: 'Outstanding Balance', value: `₹${addCommasToNumber(item.outStandingBalance)}`
                },
                item?.transactionStatus === settled &&
                    {
                        title: 'Transaction description', value: `${item.longDescription}`
                    },
            ];
            {
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) ?
                    (stepperData[0].verticalDisplayName = 'Payment accepted for settlement') :
                    (stepperData[0].verticalDisplayName = 'Withdrawal request received');
            }
            {
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT && expectedSettlingDate) ?
                    (stepperData[1].verticalDisplayName = `Settlement expected by ${getRepaymentExpectedDateBy(expectedSettlingDate)}`) :
                    (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) ?
                        (stepperData[1].verticalDisplayName = 'Settlement under processing') :
                        (stepperData[1].verticalDisplayName = 'Expected transfer by');
            }
            {
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) ?
                    (stepperData[0].verticalDescription = `Paid via ${item?.modeOfTransfer === "Unified Payments" ? "UPI" : item?.modeOfTransfer} on ${convertTimeStampToFormattedTime(item?.createdOn)}`) :
                    (stepperData[0].verticalDescription = `Placed on ${convertTimeStampToFormattedTime(item?.createdOn)}`);
            }
            {
                (item?.transactionStatus !== settled && item?.transactionType === TRANSACTION_TYPE.CREDIT) ?
                    (stepperData[1].verticalDescription = 'It may take up to 2 working days for the payment to reflect in the statement. Don’t worry, no additional interest will be charged.') :
                    (stepperData[1].verticalDescription = `${convertTimeStampToFormattedTime(item?.expectedSettlingDate)}`);
            }
            return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    zIndex: 1,
                    paddingTop: 16,
                }, onPress: () => {
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'space-between',
                        paddingHorizontal: 16,
                    } },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 20 } },
                        React.createElement(View, { style: { marginRight: 16, alignContent: 'center', alignItems: 'center' } },
                            React.createElement(Icon, { name: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                    IconTokens.Debit :
                                    IconTokens.Credit, size: IconSizeTokens.XXXXXL })),
                        React.createElement(View, { style: { flexDirection: 'column' } },
                            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: item?.transactionType !== TRANSACTION_TYPE.CREDIT ? "Withdrawal amount" : "Repayment amount", color: ColorTokens.Grey_Charcoal }),
                            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                                React.createElement(Typography, { label: `₹`, fontSize: isFontMobile() ? FontSizeTokens.XL : FontSizeTokens.MD, lineHeight: isFontMobile() ? 28 : 24, fontWeight: "600", color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                                React.createElement(View, { style: { marginBottom: 2 } },
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H3S, label: `${addCommasToNumber(item?.amount)}`, color: ColorTokens.Grey_Night })))))),
                React.createElement(View, { style: {
                        backgroundColor: 'white',
                        paddingBottom: 16
                    } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(ScrollView, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: modalHeight - 94,
                        paddingHorizontal: 16,
                    }, nestedScrollEnabled: true },
                    item?.transactionStatus !== settled && React.createElement(View, { style: {
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: "#E4E7EC",
                            paddingTop: 24,
                            paddingHorizontal: 16,
                            paddingBottom: 16,
                            marginTop: 8,
                        } },
                        React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true }),
                        (item?.longDescription !== null && item?.longDescription?.length > 0) &&
                            React.createElement(View, { style: { padding: 10, backgroundColor: '#FDF7E7', borderRadius: 6 } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2M, label: item?.longDescription }))),
                    item?.transactionStatus !== settled &&
                        React.createElement(View, { style: { marginVertical: 16 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    ListItems.map((item, index) => (React.createElement(React.Fragment, null,
                        item?.value &&
                            item?.title &&
                            item.title !== "Bank account" &&
                            React.createElement(View, { style: {
                                    paddingTop: index === 0 ? 0 : 16,
                                    paddingBottom: index === ListItems.length - 1 ? 0 : 16,
                                } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: item?.title, color: ColorTokens.Grey_Charcoal }),
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1M, label: item?.value })),
                        item?.value &&
                            item?.title &&
                            item.title === "Bank account" &&
                            React.createElement(View, { style: {
                                    paddingTop: index === 0 ? 0 : 16,
                                    paddingBottom: index === ListItems.length - 1 ? 0 : 16,
                                    flexDirection: 'row', justifyContent: 'space-between',
                                } },
                                React.createElement(View, null,
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: item?.title, color: ColorTokens.Grey_Charcoal }),
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1M, label: item?.value })),
                                React.createElement(View, null,
                                    React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`, defaultUri: "https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png", size: ImageSizeTokens.SIZE_40 }))),
                        (index < (ListItems.length - 1)) &&
                            item?.value &&
                            item?.title &&
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 })))))));
        }
    };
    const renderTransactionCards = (month, item, index, dataLength) => {
        const transactionStatus = item?.transactionStatus;
        return (React.createElement(View, { nativeID: 'txt_transactions_' + month + (index + 1), style: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                backgroundColor: 'white',
                paddingHorizontal: 16,
                ...isfromTDL && { borderRadius: 12 },
            } },
            React.createElement(TouchableOpacity, { style: styles.transactionCardContainer, onPress: () => selectTransaction(item, index) },
                React.createElement(View, { style: {
                        marginRight: 12,
                        ...isfromTDL && { top: 12 }
                    } },
                    React.createElement(Icon, { name: isfromTDL ? item?.transactionType === TRANSACTION_TYPE.CREDIT ? IconTokens.DebitTdl : IconTokens.CreditTdl : item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                            IconTokens.Debit :
                            IconTokens.Credit, size: IconSizeTokens.XXXXXL })),
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                    } },
                    React.createElement(View, { style: styles.transactionTopCardContainer },
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                                justifyContent: 'space-between'
                            } },
                            React.createElement(View, { style: { flexDirection: 'column', flexShrink: 1 } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: `${item?.description} ` }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: `${transactionStatus === pendingSettlement ? convertTimeStampToMonth(item.createdOn) : convertTimeStampToMonth(item.settledOn)}`, color: ColorTokens.Grey_Charcoal }))),
                            item?.transactionStatus !== FAILED ?
                                React.createElement(View, { style: { flexDirection: 'column', alignSelf: 'flex-end' } },
                                    React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' } },
                                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                                `+ ₹${addCommasToNumber(item?.amount)}` :
                                                `- ₹${addCommasToNumber(item?.amount)}`, color: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                                ColorTokens.Secondary_100 :
                                                ColorTokens.Grey_Night }),
                                        React.createElement(View, { style: { marginLeft: 4 } },
                                            React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.LG, color: ColorTokens.Grey_Night }))),
                                    transactionStatus === pendingSettlement ?
                                        React.createElement(View, { style: { marginTop: 4, alignSelf: 'flex-end' } }, transactionPendingCard())
                                        : React.createElement(React.Fragment, null))
                                : React.createElement(React.Fragment, null),
                            item?.transactionStatus === FAILED ?
                                React.createElement(View, { style: { flexDirection: 'column', alignSelf: 'flex-end' } },
                                    React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' } },
                                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: item?.transactionType === TRANSACTION_TYPE.CREDIT ?
                                                `+ ₹${addCommasToNumber(item?.amount)}` :
                                                `- ₹${addCommasToNumber(item?.amount)}`, color: ColorTokens.Grey_Smoke }),
                                        item?.transactionStatus === FAILED ?
                                            React.createElement(View, { style: { marginLeft: 4 } },
                                                React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.LG, color: ColorTokens.Grey_Night }))
                                            : React.createElement(React.Fragment, null)),
                                    React.createElement(View, { style: { marginTop: 4, alignSelf: 'flex-end' } }, showTransactionFailedCard()))
                                : React.createElement(React.Fragment, null))),
                    !showOutstanding
                        ? React.createElement(React.Fragment, null)
                        : transactionStatus === settled
                            ? React.createElement(View, { style: { marginTop: 3 } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: `Outstanding: ₹${addCommasToNumber(item?.outStandingBalance)}`, color: ColorTokens.Grey_Charcoal })) : React.createElement(React.Fragment, null))),
            (index < (dataLength - 1)) ?
                React.createElement(View, { style: {
                        width: '100%',
                        // paddingBottom: 16
                    } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk_1 }))
                : React.createElement(React.Fragment, null)));
    };
    const noTransactionScreen = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                } },
                React.createElement(Image, { size: ImageSizeTokens.MD, uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_transactions.svg`, width: 180, height: 180 }),
                React.createElement(View, { style: { height: 24 } }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H3B, label: `No transactions to show` }))));
    };
    const renderTransactionGroupByMonth = ({ item, index }) => {
        const month = item?.monthYear?.split('-')[0];
        const year = item?.monthYear?.split('-')[1];
        return (React.createElement(View, { style: [styles.groupContainer, { paddingTop: index === 0 ? 16 : 0, paddingBottom: 24 }] },
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    marginBottom: 16
                } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2S, label: `${month?.toUpperCase()} ${year}`, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    ...isfromTDL && {
                        borderWidth: 1,
                        borderColor: '#78787D3D',
                        borderRadius: 12,
                        marginHorizontal: 12
                    }
                } }, item?.data?.map((eachTransactionItem, index) => renderTransactionCards(month, eachTransactionItem, index, item.data.length)))));
    };
    const _headerChild = useMemo(() => {
        return !showBottomNavBar ? (React.createElement(View, { style: { width: '100%', marginHorizontal: -16, marginRight: -24 } },
            React.createElement(CustomHeader, { title: "Transactions", hideNeedHelp: true, triggerAction: triggerAction, goBackAction: goBackAction, hideDivider: true }))) : (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(View, null,
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4R, label: 'Transactions' })),
            React.createElement(View, null, _showEmail && platform !== "LARK"
                && React.createElement(TouchableOpacity, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        paddingVertical: 4,
                        paddingHorizontal: 8,
                        backgroundColor: colorMapping[ColorTokens.Primary_05],
                        borderRadius: 24,
                        alignItems: 'center'
                    }, onPress: () => goToEmailScreenAction() },
                    React.createElement(Icon, { name: IconTokens.Email, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 }),
                    React.createElement(View, { nativeID: "txt_transactions_email", style: { width: 4 } }),
                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B3M, label: 'Email', color: ColorTokens.Primary_100 }),
                    React.createElement(View, { style: { width: 8 } }),
                    emailLoading && React.createElement(ActivityIndicator, { color: colorMapping[ColorTokens.Primary_100], size: 8 })))));
    }, [emailLoading]);
    const emailStatementSection = useMemo(() => {
        return (React.createElement(View, { style: {
                borderWidth: 1,
                borderColor: colorMapping[ColorTokens.Grey_Chalk],
                backgroundColor: colorMapping[ColorTokens.White],
                paddingTop: 16,
                paddingBottom: 16,
                paddingLeft: 24,
                paddingRight: 24,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(View, null,
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: "Looking for older transactions?", color: ColorTokens.Grey_Night })),
            React.createElement(View, null,
                React.createElement(TouchableOpacity, { activeOpacity: 0, style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }, onPress: goToEmailScreenAction },
                    React.createElement(Text, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: "To receive complete transaction history over email. ", color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3B, label: "Click here", color: ColorTokens.Primary_100 }),
                        React.createElement(View, { style: { width: 8 } }),
                        emailLoading &&
                            React.createElement(ActivityIndicator, { size: 12, color: colorMapping[ColorTokens.Primary_100] }))))));
    }, [emailLoading]);
    const _bodyChild = useMemo(() => {
        const month = data?.monthYear?.split('-')[0];
        return (React.createElement(React.Fragment, null, _data &&
            _data.length === 0 ?
            noTransactionScreen() :
            React.createElement(ScrollView, { style: {
                    height: '100%',
                    paddingBottom: 16,
                    marginBottom: Platform.OS === 'ios' ? 42 : 0,
                } },
                React.createElement(View, { style: { height: 16 } }),
                tempData !== undefined && tempData?.length > 0 &&
                    React.createElement(View, { style: { marginVertical: 8, paddingHorizontal: 16 } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Transactions under processing" })),
                React.createElement(View, { style: isfromTDL && tempData?.length > 0 ? {
                        borderWidth: 1,
                        borderRadius: 12,
                        borderColor: '#78787D3D',
                        marginHorizontal: 12
                    } : {} }, tempData &&
                    tempData.map((item, index) => renderTransactionCards(month, item, index, tempData.length))),
                React.createElement(View, { style: { height: 16 } }),
                settledData !== undefined && settledData?.length > 0 &&
                    React.createElement(View, { style: { marginVertical: 8, paddingHorizontal: 16 } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Completed transactions" })),
                settledData !== undefined && settledData?.length > 0 &&
                    settledData.map((item, index) => renderTransactionGroupByMonth({ item, index })),
                _settleDataLength >= 100 &&
                    emailStatementSection,
                React.createElement(View, { style: { height: 16 } }))));
    }, [_data, data, emailLoading]);
    const showEmailContent = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } }, type === 'FAILED' ? React.createElement(Icon, { name: IconTokens.SystemError }) :
                React.createElement(Icon, { name: IconTokens.Success, color: ColorTokens.Green_10, size: IconSizeTokens.Size56 })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: title })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: subTitle })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: ctaLabel, onPress: handleCloseEmailModal, isDisabled: false }))));
    };
    const _footerChild = useMemo(() => {
        return !showModal && !showWithdrawalRejectedCard && !showRepaymentRejectedCard ? (React.createElement(View, { style: {
                width: '100%',
            } },
            React.createElement(AppBottomNav, { currentRoute: 'TRANSACTIONS', navigationAction: navigationAction, triggerAction: triggerAction }))) : (React.createElement(View, null));
    }, [showModal, showWithdrawalRejectedCard, showRepaymentRejectedCard]);
    return (React.createElement(View, { style: [
            styles.container,
            { height: height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: showBottomNavBar ? styles.header : styles.noBottomBarHeader }, _headerChild),
            React.createElement(View, { style: [{ backgroundColor: isfromTDL ? colorMapping[ColorTokens.White] : colorMapping[ColorTokens.Primary_05] }, { height: (showBottomNavBar && platform === 'REDVISION') ? height - 70 : showBottomNavBar ? height - 138 : height - 70 }] }, _bodyChild),
            (showBottomNavBar && platform !== 'REDVISION') ?
                React.createElement(View, { style: styles.footer }, _footerChild)
                :
                    React.createElement(View, null)),
        (showModal || showWithdrawalRejectedCard || showRepaymentRejectedCard) &&
            React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                } },
                React.createElement(BottomSheet, { id: "bt_transactions_cancel", autoAdjustHeight: false, height: showWithdrawalRejectedCard && !repaymentRejectedCard && !showRepaymentRejectedCard ? 322 : repaymentRejectedCard || showRepaymentRejectedCard ? Platform.OS !== "web" ? 600 : 500 : modalHeight, width: '100%', closeFunction: () => {
                        setShowWithdrawalRejectedCard(false);
                        setShowModal(false);
                        setShowRepaymentRejectedCard(false);
                    }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height + 5 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter())),
        showEmailModal &&
            React.createElement(View, { style: {
                    bottom: 0,
                    position: 'absolute',
                    zIndex: 999,
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobileView() ? 240 : 210, width: '100%', closeFunction: handleCloseEmailModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: Dimensions.get('window').height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, showEmailContent()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
// @ts-ignore
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        marginTop: Platform.OS === 'ios' ? 34 : 0,
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    noBottomBarHeader: {
        marginTop: Platform.OS === 'ios' ? 34 : 0,
        paddingTop: 12,
        paddingLeft: 16,
        backgroundColor: '#FFF',
        height: 66,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    body: {
        backgroundColor: '#F3F5FC',
    },
    footer: {
        position: 'absolute',
        paddingBottom: Platform.OS === "ios" ? 12 : 0,
        bottom: 0,
        zIndex: 99,
        width: '100%',
        // backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'white',
        paddingVertical: 16
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        paddingVertical: 16,
        justifyContent: 'space-between',
    },
    transactionTopCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 2,
    },
    transactionBottomCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
    },
});
export default (TransactionPageRevamp);
